/**
 * 站点数据源
 * 把原来散落在 6 个 HTML 页面 + js/main.js 里的文案、导航、产品、新闻等
 * 统一收敛到单一数据源，页面组件只负责渲染。
 */

/* ---------------- 联系方式 ---------------- */
export const CONTACT = {
  phone: '+86 18820037803',
  phoneHref: 'tel:+8618820037803',
  email: 'vancheen@prolinker.top',
  addr: 'Guangzhou, Guangdong, China',
  faceBook: 'ProLinker / VANCHEEN Mall',
  site: 'https://www.vancheen.com/'
}

export const COMPANY = {
  name: 'VANCHEEN',
  subtitle: 'Auto Parts & Building Materials'
}

/* ---------------- 主导航 ---------------- */
export const NAV_ITEMS = [
  { key: 'home', label: 'Home', to: '/' },
  { key: 'about', label: 'About Us', to: '/about' },
  { key: 'b2b', label: 'B2B Wholesale', to: '/topProduct?BPCId=1&Active=1' },
  { key: 'b2c', label: 'B2C Retail Store', to: '/home' },
  { key: 'factory', label: 'Factory Tour', to: '/factory' },
]

/* ---------------- 两条业务线系列 ---------------- */
export const AUTO_SERIES = [
  { en: 'Chassis Parts', zh: '底盘件' },
  { en: 'Engine Parts', zh: '发动机件' },
  { en: 'Brake System', zh: '刹车系统' },
  { en: 'Suspension Parts', zh: '悬挂件' },
  { en: 'Steering System', zh: '转向系统' },
  { en: 'Body Parts', zh: '车身件' },
  { en: 'Electrical Parts', zh: '电气件' },
  { en: 'Cooling System', zh: '冷却系统' }
]

export const BUILD_SERIES = [
  { en: 'Tiles', zh: '瓷砖' },
  { en: 'Sanitary Ware', zh: '卫浴洁具' },
  { en: 'Aluminum Doors & Windows', zh: '铝门窗' },
  { en: 'Stone', zh: '石材' },
  { en: 'Pipes & Fittings', zh: '管材管件' },
  { en: 'Waterproofing', zh: '防水材料' },
  { en: 'Insulation', zh: '保温材料' }
]

/* ---------------- 页脚 ---------------- */
export const FOOTER = {
  intro:
    'VANCHEEN is a China-based industrial export supplier delivering high-quality auto parts and building materials worldwide — with OEM/ODM capability, factory-direct pricing and reliable global shipping.',
  quickLinks: [
    { label: 'About Us', to: '/about' },
    { label: 'Products', to: '/products' },
    { label: 'Factory Tour', to: '/factory' },
  ],
  productLines: [
    { label: 'Auto Parts', to: '/products?cat=auto' },
    { label: 'Building Materials', to: '/products?cat=building' },
    { label: 'Chassis & Engine', to: '/products' },
    { label: 'Tiles & Sanitary Ware', to: '/products' },
    { label: 'Aluminum Windows', to: '/products' }
  ],
  social: [
    { label: 'LinkedIn', img: 'qrcode1.png' },
    { label: 'Facebook', img: 'qrcode2.png' }
  ],
  copyright: '迎客商服控股（广州）有限公司版权所有',
  legal: [
    { label: '粤ICP备20012225号-1', href: 'https://beian.miit.gov.cn/' },
    { label: 'Support', href: 'mailto:vancheen@prolinker.top' }
  ]
}

/* ---------------- 首页：Hero 轮播 ----------------
   说明：原始 index.html 中第 2 张幻灯片被注释掉，这里保持「2 张可用 + 1 张已注释」的原状，
       备用的第 2 张文案保留在 HERO_SLIDE_ARCHIVE 中，需要时直接启用。
------------------------------------------------- */
export const HERO_SLIDES = [
  {
    img: 'hero-banner-1.jpg',
    alt: 'Auto parts and building materials for export',
    eyebrow: 'GUANGZHOU VANCHEEN · Industrial Export Supplier',
    titleHtml: 'Your Proven Partner for <span class="accent">Auto Parts</span> &amp; <span class="accent">Building Materials</span>',
    subHtml:
      '<b>OEM/ODM · Global Shipping · Quality Controlled</b> — from our partner factories to your port, covering chassis, engine, brake, tiles, sanitary ware and more.',
    ctas: [{ label: 'Explore Products', to: '/products', cls: 'btn-primary' }],
    tags: ['SO 9001 Capable', 'OEM / ODM Capable', '30+ Export Countries', 'Container Shipping']
  },
  {
    img: 'hero-banner-3.jpg',
    alt: 'Global container shipping and logistics',
    eyebrow: 'Experienced Logistics',
    titleHtml: 'From Guangzhou to Your Port — <span class="accent">On Time, Consistently</span>',
    subHtml:
      '<b>Sea, air and door-to-door solutions</b> with consolidated container programs, real-time tracking and 98% on-time delivery across the Middle East, Africa and beyond.',
    ctas: [{ label: 'Browse Catalog', to: '/products', cls: 'btn-ghost-light' }],
    tags: ['FCL / LCL', 'Door-to-Door', 'Real-Time Tracking', 'DDU Available']
  }
]

export const HERO_SLIDE_ARCHIVE = [
  {
    img: 'hero-banner-2.jpg',
    alt: 'Automated factory production line',
    eyebrow: 'Factory-Direct Manufacturing',
    titleHtml: 'Engineered in Our Own Automated Factory, <span class="accent">Built to Your Spec</span>',
    subHtml:
      'Precision machining, robotic assembly and <b>end-to-end traceability quality control</b> deliver auto parts built to strict quality specifications at competitive factory pricing.',
    ctas: [
      { label: 'Take the Factory Tour', to: '/factory', cls: 'btn-primary' },
      { label: 'Our QC Process', to: '/quality', cls: 'btn-ghost-light' }
    ],
    tags: ['CNC Machining', 'Robotic Assembly', 'In-House QC Lab', 'Custom Tooling']
  }
]

/* ---------------- 首页：数字统计 ---------------- */
export const STATS = [
  { value: 15, suffix: '+', label: 'YEARS OF EXPORT' },
  { value: 30, suffix: '+', label: 'COUNTRIES SERVED' },
  { value: 2000, suffix: '+', label: 'SKUs SUPPLIED' },
  { value: 98, suffix: '%', label: 'ON-TIME DELIVERY' }
]

/* ---------------- 首页：两大业务支柱 ---------------- */
export const PILLARS = [
  {
    key: 'auto',
    to: '/topProduct?BPCId=1&Active=1',
    tag: 'Auto Parts',
    title: '汽车配件 · Automotive Parts',
    img: 'hero-banner-2.jpg',
    alt: 'Auto parts manufacturing',
    desc: 'Precision-engineered auto parts — chassis, engine, brake, suspension, steering, cooling and more, for passenger and commercial vehicles, sourced from trusted OEM/aftermarket manufacturers.',
    series: ['Chassis', 'Engine', 'Brake', 'Suspension', 'Steering', 'Cooling'],
    linkText: 'Explore Auto Parts'
  },
  {
    key: 'building',
    to: '/topProduct?BPCId=1&Active=1',
    tag: 'Building Materials',
    title: '建筑材料 · Building Materials',
    img: 'marble.jpg',
    alt: 'Building materials',
    desc: 'Tiles, sanitary ware, aluminum windows & doors, stone, pipes and waterproofing — durable materials for residential and commercial projects across the Middle East, Africa and Asia, sourced from trusted manufacturers.',
    series: ['Tiles', 'Sanitary Ware', 'Aluminum Windows', 'Stone', 'Pipes', 'Waterproofing'],
    linkText: 'Explore Building Materials'
  }
]

/* ---------------- 首页：精选产品（4 + 4） ---------------- */
export const FEATURED_AUTO = [
  {
    cat: 'auto',
    tag: 'Chassis',
    img: 'control-arm.jpg',
    alt: 'Suspension control arm',
    name: 'Control Arms & Suspension Bushings',
    en: 'Chassis Parts · 底盘件',
    desc: 'Lower & upper control arms, ball joints and bushings in forged / stamped steel with anti-rust coating.',
    meta: []
  },
  {
    cat: 'auto',
    tag: 'Engine',
    img: 'engine-piston.jpg',
    alt: 'Engine piston and connecting rod',
    name: 'Pistons, Connecting Rods & Engine Parts',
    en: 'Engine Parts · 发动机件',
    desc: 'Complete engine internals for petrol & diesel — pistons, rings, rods, gaskets and timing kits.',
    meta: []
  },
  {
    cat: 'auto',
    tag: 'Brake',
    img: 'brake.jpg',
    alt: 'Brake disc and caliper',
    name: 'Brake Discs, Pads & Calipers',
    en: 'Brake System · 刹车系统',
    desc: 'High-carbon brake discs with anti-rust coating, ceramic/semi-metallic pads and reman calipers.',
    meta: []
  },
  {
    cat: 'auto',
    tag: 'Steering',
    img: 'tie-rod.jpg',
    alt: 'Tie rod end steering part',
    name: 'Tie Rod Ends & Steering Linkage',
    en: 'Steering System · 转向系统',
    desc: 'Inner/outer tie rods, drag links and rack ends with precision threads and long-life boots.',
    meta: []
  }
]

export const FEATURED_BUILDING = [
  {
    cat: 'building',
    tag: 'Tiles',
    img: 'ceramic-tiles.jpg',
    alt: 'Ceramic glazed tiles',
    name: 'Ceramic & Porcelain Tiles',
    en: 'Tiles · 瓷砖',
    desc: 'Glazed, polished and full-body tiles in 600×600, 800×800, 600×1200 formats with PEI grading.'
  },
  {
    cat: 'building',
    tag: 'Sanitary',
    img: 'faucet.jpg',
    alt: 'Bathroom faucet and basin',
    name: 'Sanitary Ware & Bathroom Fittings',
    en: 'Sanitary Ware · 卫浴洁具',
    desc: 'Basins, toilets, chrome faucets and showers — water-saving, lead-free brass construction.'
  },
  {
    cat: 'building',
    tag: 'Aluminum',
    img: 'aluminum-window.jpg',
    alt: 'Aluminum window and door frames',
    name: 'Aluminum Doors & Windows',
    en: 'Aluminum Doors & Windows · 铝门窗',
    desc: 'Thermal-break sliding & casement systems with powder coating in RAL colors for desert climates.'
  },
  {
    cat: 'building',
    tag: 'Stone',
    img: 'marble.jpg',
    alt: 'Marble stone slabs',
    name: 'Marble & Natural Stone Slabs',
    en: 'Stone · 石材',
    desc: 'White, beige and grey marble slabs & tiles, calibrated and resin-treated for easy installation.'
  }
]

/* ---------------- 首页：Why VANCHEEN（10 个教训） ---------------- */
export const LESSONS = [
  {
    title: 'You drew it clearly. The factory read it differently.',
    what: `You send detailed drawings, the factory says "no problem." The bulk arrives — wrong dimensions, doesn't fit. The factory shrugs: "We understood it another way."`,
    help: 'We translate your drawings into shop-floor instructions. First article verification before full production — both sides on the same page before we run the batch.'
  },
  {
    title: 'Sample says OK. Bulk says not OK. What happens',
    what: `You approve the sample. Bulk arrives — 304 steel became 201, plating thinner, density lower. Factory says "samples are handmade, differences are normal." You have photos, but no physical sample. No proof, no leverage.`,
    help: 'We keep a sealed physical sample signed by both parties. First article checked against it before mass production. Hard evidence for any dispute.'
  },
  {
    title: `Quality standards were never put in writing. Now it's your word against theirs.`,
    what: `You say "welds aren't smooth." Factory says "this is standard quality." You realize — acceptable color variation? Scratch limits? Never written down. Each side has their own standard. No resolution.`,
    help: `We sign a written Quality Acceptance Standard with the factory — clear tolerances, defect grades, line by line. Attached to the contract. If it doesn't meet the standard, we don't accept it.`
  },
  {
    title: `The factory looks huge on paper, but can't feed your order.`,
    what: `Factory PPT says "500 million output, 500 employees." You order, pay deposit. Delivery comes — "equipment failure," "environmental inspection," "raw material shortage." Three months later, goods still scattered on the workshop floor. Turns out: only two production lines. Peak season pushes your order to the back.`,
    help: `We visit every factory — count actual lines, check three-month production schedules, review on-time delivery history. We don't recommend factories running over 80% capacity. Your order goes to a line with real room to produce.`
  },
  {
    title: `Three quotes for the same job. The cheapest one isn't always the best deal.`,
    what: 'Three quotes: $50k, $42k, $75k. You pick the cheapest. Goods arrive — 3mm steel became 2.5mm, standard bolts became substandard, two paint coats became one. Same drawing, different grade. You compared numbers, not what was cut out behind them.',
    help: 'We break down every quote — material grade, coating thickness, process, margin. For suspiciously low quotes, we dig into material sources and process plans. We compare price on the same standard, not just who has the smaller number.'
  },
  {
    title: 'You did the math on the goods. Then freight ate your profit.',
    what: `You think you got a good purchase price. Then the freight bill arrives — ocean freight, bunker surcharge, overweight surcharge — nearly half the cargo value. A few extra tons of tiles = overweight fine. Too few sofas = per-unit freight spikes. You don't see these costs until the goods are ready. By then, no turning back.`,
    help: 'For heavy cargo — precise load distribution, no fines, no wasted tonnage. For bulky cargo — optimized loading sequences to maximize container space. We compare shipping lines and schedules for you. Smart planning, effective cost control.'
  },
  {
    // 原文此处第一个色块误用了 .help 类，这里保持原样（whatClass 用于还原）
    whatClass: 'help',
    title: 'No one watched the loading. Now no one owns the damage.',
    what: `Container opens at destination — chipped tiles, scratched sofas, crushed packaging. Factory says "left in good condition." Forwarder says "internal damage isn't our responsibility." No one takes the blame. You cover the loss.`,
    help: `We supervise loading in person — intact packaging before loading, heavy at bottom, light on top, no crushing. Full photo and video record, seal number logged. If anything arrives damaged, the visual record clarifies responsibility.`
  },
  {
    title: `Three product categories, three factories — and you're running three shows by yourself.`,
    what: `Building materials from A, furniture from B, auto parts from C. A says "delay one week," B says "change packaging," C says "pay before ship." Three delivery dates, three packaging standards, three logistics flows — all on you. Your entire day is answering messages or waiting for them.`,
    help: 'We become your single point of contact. All timelines in one tracker, all packaging standards coordinated, all logistics milestones tracked. Weekly consolidated progress report. One window, three factories.'
  },
  {
    title: `The factory needs an answer. You're sound asleep across the ocean.`,
    what: `Line breakdown, environmental inspection, material shortage — factory contacts you the moment something happens. But it's 3 AM on your side. By the time you wake up and reply, the line has been idle for half a day. Small issue = three days lost. Delivery slips a full week.`,
    help: 'Our local team gets on it the same day — assess the impact, work out a temporary solution with the factory. We hold things together while you make the final call. We contain small issues early, before they become major delays.'
  },
  {
    title: 'One digit wrong on the paperwork. The container sits at the dock for weeks.',
    what: `One wrong digit in the HS code — customs flags your container. You need to amend documents, resubmit, visit the port — but you're not in China. Your cargo sits at the dock. Your customer calls every day.`,
    help: 'We assist with export documentation from order placement — verifying product name, material, intended use, and declared value against the actual goods. Second self-check before shipment. Complete and accurate documents — fewer errors, smoother clearance.'
  }
]

/* ---------------- 首页：工厂速览 ---------------- */
export const FACTORY_TEASER = {
  img: 'factory-cnc.jpg',
  alt: 'VANCHEEN automated factory and CNC machining',
  mediaTag: 'Our Automated Production Base',
  mediaIcon: 'factory',
  kicker: 'Factory Tour',
  title: 'See How We Make & Control Every Part',
  desc: 'Our production base in Guangzhou integrates CNC machining, robotic assembly and in-house testing. Walk the floor with us — virtually or on-site — and see exactly where your order is made.',
  checks: [
    { text: '12,000 m² production & warehousing', cls: 'done' },
    { text: '40+ CNC & automated machines', cls: 'done' },
    { text: 'Rigorous quality control processes', cls: 'done' },
    { text: 'Dedicated QC lab on site', cls: 'done' },
    { text: 'Live video tour available on request', cls: 'auto' },
    { text: 'Sample production in 7–15 days', cls: 'auto' }
  ],
  cta: { label: 'Take the Full Factory Tour', to: '/factory', cls: 'btn-primary' }
}

/* ---------------- 产品目录页 ---------------- */
export const PRODUCT_FILTERS = [
  { value: 'all', label: 'All Products' },
  { value: 'auto', label: 'Auto Parts 汽车配件' },
  { value: 'building', label: 'Building Materials 建筑材料' }
]

export const PRODUCT_CATALOG = [
  {
    cat: 'auto',
    tag: 'Chassis',
    img: 'control-arm.jpg',
    alt: 'Suspension control arm',
    name: 'Control Arms & Ball Joints',
    en: 'Chassis Parts · 底盘件',
    desc: 'Lower/upper control arms, ball joints and bushings — forged or stamped steel with anti-rust coating.',
    meta: []
  },
  {
    cat: 'auto',
    tag: 'Engine',
    img: 'engine-piston.jpg',
    alt: 'Engine piston set',
    name: 'Pistons & Engine Internals',
    en: 'Engine Parts · 发动机件',
    desc: 'Pistons, rings, connecting rods, gaskets and timing kits for petrol & diesel engines.',
    meta: []
  },
  {
    cat: 'auto',
    tag: 'Brake',
    img: 'brake.jpg',
    alt: 'Brake disc and caliper',
    name: 'Brake Discs, Pads & Calipers',
    en: 'Brake System · 刹车系统',
    desc: 'High-carbon discs, ceramic/semi-metallic pads and remanufactured calipers with anti-rust coating.',
    meta: []
  },
  {
    cat: 'auto',
    tag: 'Steering',
    img: 'tie-rod.jpg',
    alt: 'Tie rod end',
    name: 'Tie Rod Ends & Steering Linkage',
    en: 'Steering System · 转向系统',
    desc: 'Inner/outer tie rods, drag links and rack ends with precision threads and long-life boots.',
    meta: []
  },
  {
    cat: 'building',
    tag: 'Tiles',
    img: 'ceramic-tiles.jpg',
    alt: 'Ceramic tiles',
    name: 'Ceramic & Porcelain Tiles',
    en: 'Tiles · 瓷砖',
    desc: 'Glazed, polished and full-body tiles in 600×600 / 800×800 / 600×1200 with PEI grading.',
    meta: []
  },
  {
    cat: 'building',
    tag: 'Sanitary',
    img: 'faucet.jpg',
    alt: 'Bathroom faucet',
    name: 'Sanitary Ware & Fittings',
    en: 'Sanitary Ware · 卫浴洁具',
    desc: 'Basins, toilets, chrome faucets and showers — lead-free brass, water-saving designs.',
    meta: []
  },
  {
    cat: 'building',
    tag: 'Aluminum',
    img: 'aluminum-window.jpg',
    alt: 'Aluminum windows',
    name: 'Aluminum Doors & Windows',
    en: 'Aluminum Doors & Windows · 铝门窗',
    desc: 'Thermal-break sliding & casement systems, powder coated in RAL colors for desert climates.',
    meta: []
  },
  {
    cat: 'building',
    tag: 'Stone',
    img: 'marble.jpg',
    alt: 'Marble slabs',
    name: 'Marble & Natural Stone',
    en: 'Stone · 石材',
    desc: 'White, beige and grey marble slabs & tiles, calibrated and resin-treated for installation.',
    meta: []
  },
  {
    cat: 'building',
    tag: 'Pipes',
    img: 'pipes.jpg',
    alt: 'Pipes and fittings',
    name: 'Pipes & Fittings',
    en: 'Pipes & Fittings · 管材管件',
    desc: 'PPR, PVC and metal pipes with full fittings range for plumbing and drainage projects.',
    meta: []
  },
  {
    cat: 'building',
    tag: 'Waterproof',
    img: 'waterproofing.jpg',
    alt: 'Waterproofing membrane',
    name: 'Waterproofing Materials',
    en: 'Waterproofing · 防水材料',
    desc: 'APP/SBS modified bitumen membranes, liquid coatings and tapes for roof & foundation.',
    meta: []
  }
]

/* ---------------- 关于我们页 ---------------- */
export const ABOUT_INTRO = {
  img: 'hero-banner-2.jpg',
  alt: 'VANCHEEN company overview',
  mediaTag: 'Guangzhou-based Export Team',
  mediaIcon: 'users',
  kicker: 'Company Profile',
  title: 'We Turn Sourcing Complexity Into a Single, Reliable Handshake',
  paragraphs: [
    {
      text: `VANCHEEN was founded with a simple idea: global buyers shouldn't juggle dozens of factories and trading companies for auto parts and building materials. We built a focused supply chain around two industries we understand deeply, backed by our partner production base and partner plants in China.`
    },
    {
      text: 'Today our team serves distributors, wholesalers and project buyers across the Middle East, Africa, Southeast Asia and beyond — with OEM/ODM support, factory-direct pricing and end-to-end logistics.',
      style: 'margin-top:14px;'
    }
  ],
  checks: [
    { text: '15+ years of export experience', cls: 'done' },
    { text: '30+ countries served', cls: 'done' }
  ]
}

export const ABOUT_VALUES = [
  {
    icon: 'globe',
    title: 'Our Mission',
    desc: 'Simplify global sourcing for auto parts and building materials — delivering dependable quality, honest pricing and a partner who answers when it matters.'
  },
  {
    icon: 'factory',
    title: 'Our Vision',
    desc: 'To be the first-choice China sourcing partner for distributors and projects across emerging markets — known for consistency, transparency and speed.'
  },
  {
    icon: 'shield',
    title: 'Our Values',
    desc: 'Integrity in every quote. Precision in every batch. Accountability from inquiry to after-sales. Long-term relationships over short-term deals.'
  }
]

export const ABOUT_MILESTONES = [
  {
    icon: 'clock',
    title: '2015 · Founded',
    desc: 'Started export team in Guangzhou, serving the first batch of Middle East distributors.'
  },
  {
    icon: 'tag',
    title: '2020 · Building Materials Added',
    desc: 'Expanded into tiles, sanitary ware and aluminum windows to serve construction project buyers.'
  },
  {
    icon: 'users',
    title: '2025 · Manufacturing Partnerships Expanded',
    desc: 'Partnered with machining and assembly factories in Guangdong.'
  }
]

/* ---------------- 工厂页（Factory Tour：合作工厂实拍） ---------------- */
/**
 * 合作工厂实拍照片墙
 * 照片来自你订单背后的合作工厂生产线，不是样板间、不是摆拍。
 *
 * img 留空时页面渲染占位底纹（深蓝网格），拿到实拍图后把文件名填进 img 即可自动切换：
 *   img: 'factory-wooden-door.jpg'   →  图片放在 src/assets/images/ 下
 */
export const FACTORY_PHOTOS = [
  {
    tag: 'Wooden Doors',
    title: 'Wooden Door',
    img: 'woodenDoor.jpg',
    alt: 'Wooden door production line at a partner factory'
  },
  {
    tag: 'Sanitary Ware',
    title: 'Sanitary Ware',
    img: 'sanitaryWare.jpg',
    alt: 'Sanitary ware production line at a partner factory'
  },
  {
    tag: 'Glue Machinery',
    title: 'Glue Machine',
    img: 'glueMachinery.jpg',
    alt: 'Glue machinery workshop at a partner factory'
  },
  {
    tag: 'Auto Parts',
    title: 'Auto Parts',
    img: 'autoParts.jpg',
    alt: 'Auto parts production line at a partner factory'
  }
]

/* ---------------- 品控页 ---------------- */
export const QC_INTRO = {
  img: 'qc-lab.jpg',
  alt: 'VANCHEEN quality control laboratory',
  mediaTag: 'In-House QC Laboratory',
  mediaIcon: 'shield',
  kicker: 'Our Approach',
  title: 'Inspection Is Built Into Every Step, Not a Final Check',
  paragraphs: [
    `Instead of waiting for a final inspection, we control quality continuously. Each batch moves through our system with a traceable inspection record — and you're welcome to audit, request third-party inspection or monitor via live video at any stage.`
  ],
  checks: [
    { text: 'SO 9001 quality management system', cls: 'done' },
    { text: 'Full batch traceability', cls: 'done' },
    { text: 'Inspection reports shared with buyers', cls: 'done' },
    { text: 'Third-party inspection welcome', cls: 'done' }
  ]
}

export const QC_STEPS = [
  { num: '01', title: 'Supplier Audit', desc: 'Material & component suppliers are audited and re-certified annually.' },
  { num: '02', title: 'Incoming Inspection', desc: 'Raw materials and castings verified against spec before production.' },
  { num: '03', title: 'First-Article Check', desc: 'First piece of each run inspected for full dimensional conformance.' },
  { num: '04', title: 'In-Process Control', desc: 'Dimensional & surface checks at each machining / assembly stage.' },
  { num: '05', title: 'Lab Testing', desc: 'Hardness, coating thickness, porosity and material analysis in-house.' },
  { num: '06', title: 'Functional Test', desc: 'Moving parts tested for torque, travel and assembly fit.' },
  { num: '07', title: 'Packaging Check', desc: 'Export packaging verified for moisture, shock and seaworthiness.' },
  { num: '08', title: 'Final AQL Sampling', desc: 'Random sampling per ISO 2859-1 (AQL 1.5 / 2.5) before release.' }
]

export const QC_BADGES = [
  'SO 9001:2015',
  'ECE R90 (Brake)',
  'ISO 13006 (Tiles)',
  'ISO 2859-1 AQL',
  'CE (Sanitary)'
]

/* ---------------- 新闻页 ---------------- */
export const NEWS = [
  {
    img: 'hero-banner-3.jpg',
    alt: 'Automechanika Dubai exhibition',
    date: 'Jul 2026 · Event',
    title: 'VANCHEEN to Exhibit at Automechanika Dubai 2026',
    desc: `Meet our export team at the region's largest automotive aftermarket show. New chassis and brake programs for the GCC market on display.`
  },
  {
    img: 'hero-banner-2.jpg',
    alt: 'New robotic assembly line',
    date: 'Jun 2026 · Factory',
    title: 'New Robotic Assembly Line Online at Our Guangzhou Plant',
    desc: 'Capacity for brake and chassis components grows 40%, cutting lead times for high-volume export orders.'
  },
  {
    img: 'warehouse.jpg',
    alt: 'Consolidated container program',
    date: 'May 2026 · Logistics',
    title: 'Consolidated Container Program Now Covers Jebel Ali & Beyond',
    desc: 'Mix auto parts and building materials in one container with a fixed sailing schedule and transparent freight pricing.'
  },
  {
    img: 'ceramic-tiles.jpg',
    alt: 'The Big 5 Saudi construction exhibition',
    date: 'Apr 2026 · Event',
    title: 'Building Materials Line at The Big 5 Saudi',
    desc: 'Tiles, sanitary ware and aluminum windows tailored to the Saudi construction boom — featuring desert-climate tested finishes.'
  },
  {
    img: 'qc-lab.jpg',
    alt: 'Enhanced QC lab testing',
    date: 'Mar 2026 · Quality',
    title: 'QC Lab Expands Coating & Material Testing Capability',
    desc: 'New coating-thickness and material-analysis equipment shortens certification lead time for OEM projects.',
    more: { label: 'Our QC Process', to: '/quality' }
  },
  {
    img: 'marble.jpg',
    alt: 'New stone series launch',
    date: 'Jan 2026 · Products',
    title: 'New Marble & Quartz Series Added to Stone Program',
    desc: 'Six new stone finishes now available in full slabs and cut-to-size formats for interior fit-out projects.',
    more: { label: 'View Series', to: '/products?cat=building' }
  }
]

/* ---------------- 各页 CTA 条 ---------------- */
export const CTA = {
  about: {
    title: `Let's Build a Long-Term Partnership`,
    desc: `Tell us about your market and target products — we'll prepare a tailored sourcing proposal.`,
    actions: [{ label: 'Browse Products', href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1', external: true, }]
  },
  products: {
    title: 'Need OEM / ODM Customization?',
    desc: 'Send your drawings, samples or target specifications — our engineers respond with a feasibility check and quotation within 24 hours.',
    actions: [{ label: 'Back to Home', to: '/' }]
  },
  factory: {
    title: 'Want to see a specific factory?',
    desc: "Tell us which product or factory you'd like to see — we'll arrange a video walk-through or on-site visit at our partner factory.",
    actions: [
      {
        label: 'Request a Factory Visit',
        href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1',
        external: true,
      }
    ]
  },
  quality: {
    title: 'Want to Verify Quality Yourself?',
    desc: 'We support pre-shipment inspections by your team or a third-party agency — and share live production updates on request.',
    actions: [{ label: 'Factory Tour', to: '/factory' }]
  },
  news: {
    title: 'Get the Latest Catalogs & Price Lists',
    desc: 'Subscribe or contact us to receive new product series, market reports and freight schedules directly.',
    actions: [{ label: 'Browse Products', href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1', external: true, }]
  },
  home: {
    title: 'Ready to Source Auto Parts & Building Materials?',
    desc: 'Send us your target parts or materials and quantities — get a detailed quote with direct pricing, lead time and freight estimate.',
    actions: [
      { label: 'Browse Products', href: 'https://www.vancheen.com/topProduct?BPCId=1&Active=1', external: true, cls: 'btn-ghost-light' }
    ]
  }
}
